import {
  getSendEmailStepConfigService,
  getSendPushStepConfigService,
  getSendWhatsAppStepConfigService,
} from '@/services/stepConfigService'
import {NodeTypeEnum} from '@/types/NodeTypeEnum'
import {
  GetSendEmailStepConfigResponse,
  GetSendPushStepConfigResponse,
  GetSendWhatsAppStepConfigResponse,
} from '@/types/StepConfigParams'

export type StepConfigResult =
  | GetSendPushStepConfigResponse
  | GetSendWhatsAppStepConfigResponse
  | GetSendEmailStepConfigResponse

export function getStepConfigUseCase(type: NodeTypeEnum, signal?: AbortSignal): Promise<StepConfigResult> {
  switch (type) {
    case NodeTypeEnum.sendPush:
      return getSendPushStepConfigUseCase(signal)
    case NodeTypeEnum.sendWhatsApp:
      return getWhatsAppStepConfigUseCase(signal)
    case NodeTypeEnum.sendEmail:
      return getSendEmailStepConfigUseCase('EMAIL', 'JOURNEY', signal)
    default:
      throw new Error(`Unsupported step type: ${type}`)
  }
}

function getSendPushStepConfigUseCase(signal?: AbortSignal): Promise<GetSendPushStepConfigResponse> {
  return getSendPushStepConfigService(null, signal)
}

function getWhatsAppStepConfigUseCase(signal?: AbortSignal): Promise<GetSendWhatsAppStepConfigResponse> {
  return getSendWhatsAppStepConfigService(null, signal)
}

export function getSendEmailStepConfigUseCase(
  channel: string,
  scope: string,
  signal?: AbortSignal
): Promise<GetSendEmailStepConfigResponse> {
  return getSendEmailStepConfigService({channel, scope}, signal)
}
